import React from 'react';
import { useNavigation } from '../../hooks/useContent';
import { useTheme } from '../../hooks/useTheme';
import { Logo } from '../common/Logo';

interface NavigationProps {
  onSimulateClick: () => void;
}

const Navigation: React.FC<NavigationProps> = ({ onSimulateClick }) => {
  const { navigation } = useNavigation();
  const { getBackgroundClass, getBorderClass } = useTheme();
  
  if (!navigation) {
    return null;
  }
  
  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 ${getBackgroundClass('secondary')} backdrop-blur-md ${getBorderClass('primary')}`}>
      <div className="container mx-auto px-6">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <div className="flex items-center space-x-3">
            <Logo variant="horizontal" width={160} height={36} />
          </div>
          
          {/* CTA Button */}
          <div className="overflow-hidden">
            <button
              onClick={onSimulateClick}
              className="px-6 py-2 bg-gradient-to-r from-teal-400 to-sky-500 text-white font-semibold rounded-full shadow-lg transition-transform duration-300 transform hover:scale-105"
              style={{ transformOrigin: 'center center' }}
              >
                Orçamento Gratuito
              </button>
          </div>
        </div>

      </div>
    </nav>
  );
};

export { Navigation };
